import React, { Component } from "react";

export default class TextPdfPreview extends Component {
  constructor(props) {
    super(props);
    console.log("Props", this.props);
    this.state = {
      content: this.props.content + ".doc",
      //http://204.48.26.50:8039/api/download/f682149509ae4c8d8ad8be802d255eac
      heading: this.props.heading,
      desc: this.props.description,
      isPDF: -1,
    };
  }

  componentDidMount() {
    console.log("state", this.state.content);
    if (this.state.content.indexOf(".pdf") != -1) {
      console.log("isPDF", this.state.content.indexOf("pdf"));
      this.setState({
        isPDF: 1,
      });
    } else {
      console.log("isDoc", this.state.content.indexOf("doc"));
      this.setState({
        isPDF: -1,
      });
    }
  }

  render() {
    console.log("Text Preview text", this.state);
    if (this.state.isPDF == -1) {
      return (
        <div className="text-center">
          <h2>{this.state.heading}</h2>
          <p>{this.state.desc}</p>
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              title="document"
              src={`http://docs.google.com/gview?url=${this.state.content}&embedded=true`}
            ></iframe>
          </div>
        </div>
      );
    } else {
      return (
        <div className="text-center">
          <h2>{this.state.heading}</h2>
          <p>{this.state.desc}</p>
          <div className="embed-responsive embed-responsive-16by9">
            <iframe src={`${this.state.content}.pdf`} title="document">
              <p>Your Browser dont support iFrame</p>
            </iframe>
          </div>
        </div>
      );
    }
  }
}
